<ion-content class="ion-no-padding">
  <div class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">{{ heading || "Audit History" }}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">

          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>

      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">History Details</ion-title>
      </div>
      <div class="grid-main-container mt-2 px-2" *ngIf="allData">
        <div class="grid-view-main-container">
          <div class="table-container">
            <table class="table" *ngIf="allData.data">
              <thead class="thead-dark sticky-top">
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">Changed Date</p>
                  </div>
                </th>
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">Changed By</p>
                  </div>
                </th>
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">Event</p>
                  </div>
                </th>
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">Changed Field</p>
                  </div>
                </th>
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">Old Value</p>
                  </div>
                </th>
                <th>
                  <div class="table-heading">
                    <p class="text mb-0">New Value</p>
                  </div>
                </th>
              </thead>

              <tbody>
                <ng-container *ngFor="let row of allData.data">
                  <ng-container *ngFor="let change of row.changes; let i = index">
                    <tr>
                      <td *ngIf="i === 0" [attr.rowspan]="row.changes.length">
                        {{ row.modifiedDate | date: 'MMM d, yyyy' }}
                      </td>
                      <td *ngIf="i === 0" [attr.rowspan]="row.changes.length">{{ row.modifiedBy }}</td>
                      <td *ngIf="i === 0" [attr.rowspan]="row.changes.length">{{ row.action }}</td>
                      <td>{{ change.field || "--" }}</td>
                      <td>
                        <div (click)="toggleExpanded(change, 'oldValue')"
                          [innerHTML]="getShortenedHtml(change.field, change.oldValue)"></div>
                      </td>
                      <td>
                        <div (click)="toggleExpanded(change, 'newValue')"
                          [innerHTML]="getShortenedHtml(change.field, change.newValue)"></div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>


                <tr *ngIf="allData?.data.length === 0">
                  <td colspan="6" class="text-center">
                    <p class="my-2">No Results Found!</p>
                  </td>
                </tr>
              </tbody>


            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>